/**
 * Resolve the invoice key for API routes and child props.
 * Prefer business invoice_id (e.g. SH000123) over numeric PK id.
 */
export function resolveInvoiceApiKey(source) {
  if (source == null || source === '') return null
  if (typeof source === 'object') {
    const key = source.invoice_id
      || source.invoice_number
      || source.invoiceId
      || source.id
      || null
    return key != null && key !== '' ? String(key) : null
  }
  return String(source)
}
